export default {
  layout: {
    rows: [
      {
        fields: [ { name: "specimen.label" } ]
      },

      {
        fields: [ { name: "specimen.barcode" } ]
      },

      {
        fields: [ { name: "specimen.additionalLabel" } ]
      },

      {
        fields: [ { name: "specimen.status" } ]
      },

      {
        fields: [ { name: "specimen.type" } ]
      },

      {
        fields: [ { name: "specimen.imageId" } ]
      },

      {
        fields: [ { name: "specimen.initialQty" } ]
      },

      {
        fields: [ { name: "specimen.availableQty" } ]
      },

      {
        fields: [ { name: "specimen.concentration" } ]
      },

      {
        fields: [ { name: "specimen.createdOn" } ]
      },

      {
        fields: [ { name: "specimen.storageLocation" } ]
      },

      {
        fields: [ { name: "specimen.biohazards" } ]
      },

      {
        fields: [ { name: "specimen.pathology" } ]
      },

      {
        fields: [ { name: "specimen.anatomicSite" } ]
      },

      {
        fields: [ { name: "specimen.laterality" } ]
      },

      {
        fields: [ { name: "specimen.freezeThawCycles" } ]
      },

      {
        fields: [ { name: "specimen.comments" } ]
      },

      {
        fields: [ { name: "specimen.collectionEvent.time" } ]
      },

      {
        fields: [ { name: "specimen.collectionEvent.user" } ]
      },

      {
        fields: [ { name: "specimen.collectionEvent.procedure" } ]
      },

      {
        fields: [ { name: "specimen.collectionEvent.container" } ]
      },

      {
        fields: [ { name: "specimen.receivedEvent.time" } ]
      },

      {
        fields: [ { name: "specimen.receivedEvent.user" } ]
      },

      {
        fields: [ { name: "specimen.receivedEvent.receivedQuality" } ]
      }
    ]
  }
}
